import { round2 } from '../../../lib/sponsorPledgeFlowMath'

export function formatPhoneInput(value) {
  const digits = value.replace(/\D/g, '').slice(0, 10)
  if (digits.length > 6) {
    return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`
  }
  if (digits.length > 3) {
    return `(${digits.slice(0, 3)}) ${digits.slice(3)}`
  }
  if (digits.length > 0) {
    return `(${digits}`
  }
  return ''
}

export function parseCurrencyCentsInput(value) {
  const digits = String(value || '').replace(/\D/g, '')
  if (!digits) return null
  const cents = parseInt(digits, 10)
  if (!Number.isFinite(cents)) return null
  return round2(cents / 100)
}
